import { useState } from "react";
import { ChevronDown } from "lucide-react";

export function CollapsibleCard({ title, subtitle, color, icon: Icon, badge, badgeColor, children, testId }) {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="we-card overflow-hidden"
      style={{ borderLeft: `4px solid ${color}` }}
      data-testid={testId}
    >
      {/* Header — always visible */}
      <div
        className="flex items-center justify-between cursor-pointer p-4"
        onClick={() => setOpen((o) => !o)}
        data-testid={`${testId}-header`}
      >
        <div className="flex items-center gap-2.5 flex-1 min-w-0">
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0"
            style={{ background: `${color}15` }}
          >
            <Icon size={16} color={color} />
          </div>
          <div className="min-w-0">
            <div className="text-sm font-bold" style={{ color: "#2D2A24" }}>{title}</div>
            <div className="text-[11px] truncate" style={{ color: "#71644C" }}>{subtitle}</div>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          {badge && (
            <span
              className="text-[10px] font-bold px-2 py-0.5 rounded-md max-w-[110px] truncate block"
              style={{ background: `${badgeColor || color}15`, color: badgeColor || color }}
              title={badge}
            >
              {badge}
            </span>
          )}
          <ChevronDown
            size={16}
            color="#B5A998"
            style={{
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s ease",
            }}
          />
        </div>
      </div>

      {/* Expandable content */}
      <div
        style={{
          display: "grid",
          gridTemplateRows: open ? "1fr" : "0fr",
          transition: "grid-template-rows 0.35s ease",
        }}
      >
        <div style={{ overflow: "hidden" }}>
          <div className="px-4 pb-4 pt-1" style={{ borderTop: "1px solid #E2D9CB" }}>
            {typeof children === "function" ? children(open) : children}
          </div>
        </div>
      </div>
    </div>
  );
}
